import {Component} from '@angular/core';
import {UserService} from '@iw-shop/user/services/user.service';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {getSelectedCustomer} from '@store/selectors/user.selector';
import {Subject, takeUntil} from 'rxjs';
import {Router} from "@angular/router";

@Component({
    selector: 'layout-container-user-customer',
    standalone: false,
    templateUrl: './container-user-customer.component.html',
    styleUrls: ['./container-user-customer.component.scss']
})
export class ContainerUserCustomerComponent {
    destroy$: Subject<boolean> = new Subject<boolean>();
    customerId?: string;

    constructor(private store: Store<AppState>, private userService: UserService, private router: Router) {
        this.store.select(getSelectedCustomer).pipe(takeUntil(this.destroy$)).subscribe(r => {
            if (r) {
                this.customerId = r.id;
            } else {
                this.router.navigate(['/']).then();
            }
        })
    }

    isAccess(type: 'invoices' | 'users' | 'favorites' | 'prices'): boolean {
        return this.userService.hasLoggedInUserAccess({type, customerId: this.customerId ?? ''});
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
